import request from '@/utils/request'
// 提交表单
export const handleSubmit = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/addUserMessage',
        data: params
    })
}